import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import MyNavbar from "./components/MyNavbar/MyNavbar";
import Footer from "./components/Footer/Footer";
import Step1 from './pages/step1'
import Step2 from "./pages/step2";
import Step3 from "./pages/step3";
import Step4 from "./pages/step4";
import Step5 from "./pages/step5";
import Step6 from "./pages/step6";
import Step7 from "./pages/step7";
import Step8 from "./pages/step8";
import Step9 from "./pages/step9";
import Step10 from "./pages/step10";
import Step11 from "./pages/step11";
import Welcome from "./pages/welcome";


function App() {
  return (
      <Router>
          <MyNavbar />
          <Routes>
              <Route index path='/' element={<Welcome />} />
          </Routes>
          <Routes>
              <Route index path='/step1' element={<Step1 />} />
          </Routes>
          <Routes>
              <Route index path='/step2' element={<Step2 />} />
          </Routes>
          <Routes>
              <Route index path='/step3' element={<Step3 />} />
          </Routes>
          <Routes>
              <Route index path='/step4' element={<Step4 />} />
          </Routes>
          <Routes>
              <Route index path='/step5' element={<Step5 />} />
          </Routes>
          <Routes>
              <Route index path='/step6' element={<Step6 />} />
          </Routes>
          <Routes>
              <Route index path='/step7' element={<Step7 />} />
          </Routes>
          <Routes>
              <Route index path='/step8' element={<Step8 />} />
          </Routes>
          <Routes>
              <Route index path='/step9' element={<Step9 />} />
          </Routes>
          <Routes>
              <Route index path='/step10' element={<Step10 />} />
          </Routes>
          <Routes>
              <Route index path='/step11' element={<Step11 />} />
          </Routes>

          <Footer />
      </Router>
  );
}

export default App;
